import { Injectable } from '@angular/core';
import { Observable, Subject, filter } from 'rxjs';
import { BroadcastEvents } from '../enums/broadcast-events';

@Injectable({
  providedIn: 'root'
})
export class BroadcastService {

  private broadcastQueue = new Subject<BroadcastEvents>();

  on(eventType: BroadcastEvents): Observable<BroadcastEvents> {
    return this.broadcastQueue.pipe(filter(event => event === eventType));
  }

  dispatch(event: BroadcastEvents): void {
    this.broadcastQueue.next(event);
  }

}
